import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { BuyNowPayLaterMethod } from '@wix/cashier-core/dist/src/services/PaymentMethod/types';
import { CurrencyString } from '../../types/Currency';
import { CountryString } from '../../types/Country';
import { validateByMethodName } from '../../utils/validation';
import { sortPaymentMethodsByRank } from '../../utils/paymentMethods';

export const filterSupportedMethods = (
  paymentMethods: BuyNowPayLaterMethod[],
  currency: CurrencyString,
  amount: string,
  country: CountryString,
  locale: string
): PaymentMethod[] => {
  return sortPaymentMethodsByRank(
    paymentMethods.filter((paymentMethod) =>
      validateByMethodName({
        paymentMethod: paymentMethod.paymentMethod as PaymentMethod,
        currency,
        amount,
        country,
        locale,
      })
    )
  ) as PaymentMethod[];
};

export const areSupportedMethodsChanged = (
  prevMethods: PaymentMethod[],
  nextMethods: PaymentMethod[]
) => {
  if (prevMethods.length !== nextMethods.length) {
    return true;
  }
  return prevMethods.some((pm, i) => pm !== nextMethods[i]);
};
